__turbopack_context__.v({
  "bodyWrapper": "tab-drawer-module-scss-module__qipueq__bodyWrapper",
  "divider": "tab-drawer-module-scss-module__qipueq__divider",
  "vertical": "tab-drawer-module-scss-module__qipueq__vertical",
  "wrapper": "tab-drawer-module-scss-module__qipueq__wrapper",
});
